import { render, staticRenderFns } from "./ChildBirthCerts.vue?vue&type=template&id=c44e778a&"
import script from "./ChildBirthCerts.vue?vue&type=script&lang=js&"
export * from "./ChildBirthCerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports